module.exports = __webpack_public_path__ + "img/qr.7356a92c.png";